import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import OpsDashboard from '../OpsDashboard/OpsDashboard';
import BookingPlan from '../BookingPlan/BookingPlan';
import { TemplateShare } from '../TemplateShare';
import { ContactList } from '../ContactList';
import { ROUTESNAME } from '../../../constants/routes.constants';
import ErrorPage from '../../../components/Shared/ErrorPage';
export default function PagesRoutes() {
  return (
    <>
      <Routes>
        <Route path="*" element={<ErrorPage />} />
        <Route path={ROUTESNAME.opsDashboard} element={<OpsDashboard />} />
        <Route path={ROUTESNAME.bookingPlan} element={<BookingPlan />} />
        <Route path={ROUTESNAME.templateShare} element={<TemplateShare />} />
        <Route path={ROUTESNAME.contactList} element={<ContactList />} />
      </Routes>
    </>
  );
}
